import Component from '@glimmer/component';
import type { FilterItem } from 'garaje/models/common';

interface IntegrationFilterArgs {
  options: FilterItem[];
  selected: string[];
  onSelect: (integrations: string[]) => void;
}

export default class IntegrationFilter extends Component<IntegrationFilterArgs> {
  get selectedOptions(): FilterItem[] {
    return this.args.options.filter((opt) => this.args.selected.includes(opt.filter));
  }

  get displayText(): string {
    if (this.args.selected.length === 0) {
      return 'All integrations';
    }
    if (this.args.selected.length === 1) {
      return this.selectedOptions[0]?.name || 'All integrations';
    }
    return `${this.args.selected.length} integrations`;
  }
}
